import { type } from "../charge/utils";
import { naturalSort } from "./helpers";
import { isPlainObject } from "../utils";

const ACCOUNT_BANKS_LIST = [];
const INTERNET_BANKS_LIST = [];
const USSD_BANKS_LIST = [];

function initialize(excludesList) {
  const isProduction = this.get('env') !== 'test';
  excludesList = type(excludesList) === 'array' ? excludesList : [];

  const ACCOUNT_AVAILABLE = 0x1;
  const USSD_AVAILABLE = 0x2;
  const IBANKING_AVAILABLE = 0x4;

  const ACCESS_BANK = {
    name: 'Access Bank',
    code: '044',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE | IBANKING_AVAILABLE
  };

  const ECO_BANK = {
    name: 'Ecobank',
    code: '050',
    availability: USSD_AVAILABLE
  };

  const FCMB_BANK = {
    name: 'First City Monument Bank (FCMB)',
    code: '214',
    availability: USSD_AVAILABLE
  };

  const FIDELITY_BANK = {
    name: 'Fidelity Bank',
    code: '070',
    availability: USSD_AVAILABLE | IBANKING_AVAILABLE
  };

  const FIRST_BANK = {
    name: 'First Bank of Nigeria',
    code: '011',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE
  };

  const FSDH_BANK = {
    name: 'FSDH Merchant Bank Limited',
    code: '601',
    availability: 0
  };

  const GT_BANK = {
    name: 'GTBank',
    code: '058',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE | IBANKING_AVAILABLE
  };

  const HERITAGE_BANK = {
    name: 'Heritage Bank',
    code: '030',
    availability: USSD_AVAILABLE
  };

  const KEYSTONE_BANK = {
    name: 'Keystone Bank',
    code: '082',
    availability: USSD_AVAILABLE
  };

  const LOTUS_BANK = {
    name: 'Lotus Bank',
    code: '303',
    availability: USSD_AVAILABLE
  }

  const POLARIS_BANK = {
    name: 'Polaris Bank',
    code: '076',
    availability: 0
  };

  const PREMIUM_TRUST_BANK = {
    name: 'Premium Trust Bank',
    code: '105',
    availability: USSD_AVAILABLE
  }

  const PROVIDUS_BANK = {
    name: 'Providus Bank',
    code: '101',
    availability: (!isProduction && ACCOUNT_AVAILABLE)
  };

  const STANBIC_BANK = {
    name: 'Stanbic IBTC Bank',
    code: '221',
    availability: (!isProduction && ACCOUNT_AVAILABLE) | USSD_AVAILABLE
  };

  const STERLING_BANK = {
    name: 'Sterling Bank',
    code: '232',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE
  };

  const UBA_BANK = {
    name: 'United Bank for Africa',
    code: '033',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE
  };

  const UNION_BANK = {
    name: 'Union Bank',
    code: '032',
    availability: USSD_AVAILABLE
  };

  const UNITY_BANK = {
    name: 'Unity Bank',
    code: '215',
    availability: (!isProduction && ACCOUNT_AVAILABLE) | USSD_AVAILABLE
  };

  const VFD_MFB_BANK = {
    name: 'VFD Microfinance Bank',
    code: '090110',
    availability: USSD_AVAILABLE
  };

  const WEMA_BANK = {
    name: 'Wema Bank',
    code: '035',
    availability: USSD_AVAILABLE
  };

  const ZENITH_BANK = {
    name: 'Zenith Bank',
    code: '057',
    availability: ACCOUNT_AVAILABLE | USSD_AVAILABLE
  };

  [
    ACCESS_BANK,
    ECO_BANK,
    FCMB_BANK,
    FIDELITY_BANK,
    FIRST_BANK,
    FSDH_BANK,
    GT_BANK,
    HERITAGE_BANK,
    KEYSTONE_BANK,
    LOTUS_BANK,
    POLARIS_BANK,
    PREMIUM_TRUST_BANK,
    PROVIDUS_BANK,
    STANBIC_BANK,
    STERLING_BANK,
    UBA_BANK,
    UNION_BANK,
    UNITY_BANK,
    VFD_MFB_BANK,
    WEMA_BANK,
    ZENITH_BANK
  ]
    .sort(naturalSort('name', 'code'))
    .forEach(bank => {
      const { name, code, availability } = bank;
      const __bank__ = Object.freeze({ name, code });

      if (availability) {
        availability & ACCOUNT_AVAILABLE && (excludesList.indexOf(code) < 0) && ACCOUNT_BANKS_LIST.push(__bank__);
        availability & IBANKING_AVAILABLE && INTERNET_BANKS_LIST.push(__bank__);
        availability & USSD_AVAILABLE && USSD_BANKS_LIST.push(__bank__);
      }
    });

  Object.freeze(ACCOUNT_BANKS_LIST);
  Object.freeze(INTERNET_BANKS_LIST);
  Object.freeze(USSD_BANKS_LIST);
}

function selectBankFromList(list, bank) {
  if (type(list) !== 'array') return null;

  if (list.indexOf(bank) < 0) {
    const { name: bankName, code: bankCode } = isPlainObject(bank) ? bank : (
      /^\d{2,}$/.test(bank)
        ? { code: bank }
        : { name: String(bank) }
    );

    bank = list.find(item => {
      if (isPlainObject(item)) {
        const { name, code } = item;

        const hasName = typeof bankName !== 'undefined';
        const hasCode = typeof bankCode !== 'undefined';

        let matches = (hasName || hasCode) ? 1 : 0;

        hasName && (matches = matches & (bankName === name));
        hasCode && (matches = matches & (bankCode === code));

        return matches;
      }
    });
  }

  return bank || null;
}

export {
  ACCOUNT_BANKS_LIST,
  INTERNET_BANKS_LIST,
  USSD_BANKS_LIST,
  selectBankFromList
}

export default initialize;
